module.exports = __webpack_public_path__ + "static/media/services.6d6819f6.svg";